import { render } from "./NavBar.vue?vue&type=template&id=6149b371&scoped=true"
const script = {}

import "./NavBar.vue?vue&type=style&index=0&id=6149b371&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6149b371"]])

export default __exports__